import styled from '@emotion/styled'
import { colors, measures } from 'styles/variables'

const { unit, half } = measures

const PanelComponent = styled.div`
  padding: ${({ padded = true }) => (padded ? `${2 * unit}px` : 0)};

  ${({ bordered }) => bordered && `border: 1px solid ${colors.grays.gray3};`}
  ${({ shadowed }) =>
    shadowed && `box-shadow: 0px 1.5px 4px ${colors.black15};`}

  border-radius: ${half}px;
  background-color: linear-gradient(${colors.black100}, ${colors.grays.gray6});
`

export default PanelComponent
